import {css} from "lit";

export const sidebarHeaderStyles = [css`
	#main-container {
		display: flex;
		flex-direction: column;
		gap: 5px;
		padding-top: 10px;
	}

	#main-header {
		//height: 62px;
		//display: flex;
		//justify-content: center;
		//align-items: center;
		//position: relative;
	}

	#pn-logo {
		width: 40px;
		height: 40px;
	}

	#header-buttons-group {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: 20px;
		padding: 0 30px;
	}
	
	#header-buttons-group pn-icon-button {
		font-size: calc(var(--pn-font-size-large) + 3px);
	}

	#btn-account {
		display: block;
		width: 21px;
		height: 21px;
	}

	#btn-show-hide {
		font-size: 24px;
	}

	#btn-show-hide.rotated::part(button) {
		transform: rotate(180deg);
	}

	#restore-session-container {
		display: flex;
		gap: 10px;
		align-items: flex-end;
	}

	#restore-session-container pn-labeled-text-input {
		flex: 1;
	}

	#restore-session-container pn-labeled-text-input::part(label) {
		margin-bottom: 0;
	}

	#restore-session-container pn-button::part(button) {
		font-size: 14px;
		font-weight: 600;
	}

	#project-select-container {
		display: flex;
		align-items: center;
		padding: 16px;
		gap: 16px;
	}

	#project-select-container .project-name {
		font-family: var(--pn-font-family-base);
		margin-left: 5px;
		font-size: 18px;
	}

	#project-select-container .project-name pn-button {
		font-size: 13px;
	}

	#project-select-container pn-button {
		display: block;
		margin: -5px 0 -20px;
	}

	pn-project-selector {
		flex-grow: 1;
		min-width: 0px;
	}

	.save-project-container {
		margin: 0px auto 10px;
		max-width: 200px;
	}
`];
